// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7338":"63c9022a","9067":"63c9022a","9289":"b3f38c31"}[chunkId] + ".chunk.css";
};